<script lang="ts">
  let class_name = "";
  export { class_name as class };
  export let chromeless = false;
  export let disabled = false;
  export let style = '';
  export let rounding: 0 | 2 | 50 | 100 = chromeless ? 0 : 2;
  export let width: 'auto' | '1:1' | 'full' = '1:1';
  export let height: string | undefined = undefined;
  const _width = width == 'auto' ? 'auto' : width == 'full' ? '100%' : undefined;
</script>

<button on:click
  class={class_name}
  class:round={rounding==2}
  class:pill={rounding==50}
  class:circle={rounding==100}
  class:chromeless
  class:pad={rounding==50 || width != '1:1'}
  style:width={_width}
  style:height={height}
  {style}
  {disabled}><slot /></button>

<style lang="scss">
  button {
    --width: 48px;
    --height: 48px;
    box-sizing: border-box;
    width: var(--width);
    height: var(--height);
    margin: 0;
    padding: 0;
    background: #fff;
    color: #000;
    border: 1px solid rgba(0,0,0,0.5);
    font-family: inherit;
    font-size: 18px;
    text-shadow: none; /* liferay leaks */
    user-select: none;
  }

  button:disabled {
    opacity: .4;
  }

  .round {
    border-radius: 2px;
  }

  .pad {
    padding: 0 var(--_p1);
  }

  .pill {
    border-radius: 100px;
    font-size: inherit;
  }

  .circle {
    background: rgba(0,0,0, .75);
    border: none;
    border-radius: 50%;
    color: #fff;

    :global(.icon) {
      filter: invert(1);
    }
  }

  .chromeless {
    background: transparent;
    border: none;
  }

  

</style>